const consumedTokenKeys = new Set();

// An ssoTokenKey is single-use server-side: the auth-state change after a successful consume
// remounts the landing route before the router navigates away, and a second consume of the same
// key 404s and clobbers the already-successful login. Claiming the key at module scope survives
// both re-renders and remounts.
export const tryClaimSsoTokenKey = ssoTokenKey => {
  if (consumedTokenKeys.has(ssoTokenKey)) {
    return false;
  }

  consumedTokenKeys.add(ssoTokenKey);

  return true;
};
